export default "__VITE_PUBLIC_ASSET__b7b00383__"